import React from 'react';
import PropTypes from 'prop-types';
import exact from 'prop-types-exact';
import { connect } from 'react-redux';
import queryString from 'query-string';
import { compose, lifecycle } from 'recompose';

import SplitLayout from '../../layouts/SplitLayout/index';
import PageLayout from '../../layouts/PageLayout/index';
import FilteringPanel from './containers/FilteringPanel';
import TrirView from './containers/TrirView';

import { routerProps } from '../../propTypes';
import { getEndDateInputFormat, getStartDateInputFormat } from './selectors';
import { setEndDate, setStartDate } from './actions';

const propTypes = exact({
  startDate: PropTypes.string,
  endDate: PropTypes.string,
  setStartDateAction: PropTypes.func.isRequired,
  setEndDateAction: PropTypes.func.isRequired,

  ...routerProps,
});

const TrirReport = (props) => {
  const { startDate, endDate } = props;


  return (
    <PageLayout
      title="TRIR Report"
      render={() => {
        return (
          <SplitLayout
            leftSize={2}
            leftRender={() => { return <FilteringPanel initialValues={{ startDate, endDate }} />; }}
            rightSize={10}
            rightRender={() => { return <TrirView />; }}
          />
        );
      }}
    />
  );
};

TrirReport.propTypes = propTypes;

const mapStateToProps = (state) => {
  return {
    startDate: getStartDateInputFormat(state),
    endDate: getEndDateInputFormat(state),
  };
};

const mapDispatchToProps = {
  setStartDateAction: setStartDate,
  setEndDateAction: setEndDate,
};

const withInitPage = lifecycle({
  componentWillMount() {
    const {
      location,
      setStartDateAction,
      setEndDateAction,
    } = this.props;

    const queryStringObject = queryString.parse(location.search);
    const { startDate, endDate } = queryStringObject;

    if (startDate) {
      setStartDateAction(startDate);
    }

    if (endDate) {
      setEndDateAction(endDate);
    }
  },
});

const withRedux = connect(mapStateToProps, mapDispatchToProps);

const enhance = compose(
  withRedux,
  withInitPage,
);

export default enhance(TrirReport);
